import React from "react";
import "./AboutUs.css"; // Optional custom styles
import WelcomeUAIC from "./WelcomeUAIC";
import AboutUsUAIC from "./AboutUsUAIC";
import AboutUsServices from "./AboutUsServices";

const AboutUs = () => {
  return (
    <>
      <WelcomeUAIC />
      <AboutUsUAIC />
      <AboutUsServices />
    </>
  );
};

export default AboutUs;
